import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { motion } from "framer-motion";
import { List, X } from "@phosphor-icons/react";

const LOGO_URL = "/bch-logo.png";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/login", label: "Login" },
];

export default function PublicNav() {
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50"
      style={{ backdropFilter: "blur(20px)", background: "rgba(250,250,248,0.9)", borderBottom: "1px solid rgba(0,0,0,0.06)" }}
      data-testid="public-nav"
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20 md:h-24">
        <Link to="/"><img src={LOGO_URL} alt="BCH" className="h-20 md:h-24 w-auto" /></Link>
        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map(l => (
            <Link
              key={l.to}
              to={l.to}
              className={`text-base transition-colors duration-200 hover:text-[#1a8a6d] ${location.pathname === l.to ? "font-semibold" : "font-medium"}`}
              style={{ color: location.pathname === l.to ? "#1a8a6d" : "#555" }}
            >
              {l.label}
            </Link>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <Link to="/signup" className="hidden sm:block rounded-full px-6 py-2.5 text-base font-semibold transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
            style={{ background: "#1a8a6d", color: "#fff" }} data-testid="apply-membership-btn">Apply Now</Link>
          <button onClick={() => setMobileMenu(!mobileMenu)} className="md:hidden p-2 text-[#333]">
            {mobileMenu ? <X className="w-6 h-6" /> : <List className="w-6 h-6" />}
          </button>
        </div>
      </div>
      {mobileMenu && (
        <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="md:hidden px-6 pb-4 space-y-3" style={{ background: "rgba(250,250,248,0.98)" }}>
          {["/", "/about", "/login", "/signup"].map((p, i) => (
            <Link key={p} to={p} onClick={() => setMobileMenu(false)} className="block py-2 text-sm font-medium" style={{ color: "#555" }}>
              {["Home", "About", "Login", "Apply Now"][i]}
            </Link>
          ))}
        </motion.div>
      )}
    </nav>
  );
}
